<template>
    <div class="common-flexbox flex-content-left-align">
      <div class="container-heading">
        <img class="reg-icon calendar-check-icon" :src="calendarCheck"/>
        {{ $t('conference_call_string_status.expired') }}
      </div>
      <div class="content">{{ $t(conferenceCallEndedText) }}</div>
      </div>
</template>

<script setup>
import { computed } from 'vue';
import Constants from "@/utils/constants";
import { isWebBasedReplayEnabled } from "@/utils/helper";
import calendarCheck from '@/assets/icons/calendar_check.svg';

// Import composables
import { useConferenceCall } from '@/composables/useConferenceCall';

// Define component options
defineOptions({
  name: 'conferenceEnded'
});

// Initialize composables
const { conferenceCallDetails } = useConferenceCall();

// Computed properties
const conferenceCallEndedText = computed(() => {
  if (conferenceCallDetails.value.ShowType == Constants.ShowTypes.videoWebinar) {
    return isWebBasedReplayEnabled(conferenceCallDetails.value.ReplayType) ? Constants.WebinarEndedReplayMessage : Constants.WebinarEndedMessage;
  } else {
    return isWebBasedReplayEnabled(conferenceCallDetails.value.ReplayType) ? Constants.ConferenceReplayCallEnded : Constants.ConferenceCallEndedMessage;
  }
});
</script>

<style lang="stylus" scoped>
@import '~@/shared/styles/common.scss';
@import '~@/shared/styles/HeroContent.scss';
.calendar-check-icon {
  height: 15.83px !important;
}
.container-heading {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 0px;
  color: #000000;
  margin-bottom: 20px;
  align-self: flex-start;
  text-transform: none;
  padding: 0;
}
.content {
  padding: 0;
  align-self: flex-start;
  max-width: 500px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  text-align: left;
}

</style>

